<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body p-3">
                <div class=" mb-2 d-flex justify-content-between">
                  <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                  <span><router-link :to="{ path: '/printprofile', query: { id: this.$route.query.id } }" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span>
                </div>
                <table v-for="item in members" :key="item.id" class="table">
                  <tr>
                    <td colspan="2" class="text-center">
                      <img :src="item.member_photo" class="rounded-circle" width="100" height="100" />
                    </td>
                  </tr>
                  <tr>
                    <td>ID:</td>
                    <td class="text-primary fw-medium">{{ item.member_id }}</td>
                  </tr>
                  <tr>
                    <td>Full Name:</td>
                    <td class="text-primary fw-medium">{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Gender:</td>
                    <td class="text-primary fw-medium">{{ item.gender }}</td>
                  </tr>
                  <tr>
                    <td>Telephone:</td>
                    <td class="text-primary fw-medium">{{ item.telephone }}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td v-if="item.email" class="text-primary fw-medium">{{ item.email }}</td>
                    <td v-else class="text-danger fw-medium">No email</td>
                  </tr>
                  <tr>
                    <td> Age: </td>
                    <td class="text-primary fw-medium">{{ item.age }}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td class="text-primary fw-medium">{{ item.address }}</td>
                  </tr>
                  <tr>
                    <td>Nationality:</td>
                    <td class="text-primary fw-medium">{{ item.nationality.name }}</td>
                  </tr>
                  <tr>
                    <td>NIN:</td>
                    <td class="text-primary fw-medium">{{ item.nin }}</td>
                  </tr>
                  <!-- <button @click.prevent="showResetPasswordModal(item.member_id)"
                    class="mt-2 btn btn-sm btn-danger"><b-spinner v-if="loader" small></b-spinner> <span v-else>Reset
                      Password</span></button> -->
                </table>

                <span class="h6"><br> Savings Balance</span>: <span class="text-dark h5"> <b>{{ commas(savingbalance) }}
                    {{ userData.currency }}</b></span>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <b-tabs pills nav-class="p-0" content-class="text-primary">
              <b-tab active class="border-0">
                <template v-slot:title>Savings</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Payment Mode</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in savings" :key="item.id">
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
                          <td>{{ item.date_of_payment }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <b>Total Savings : {{ commas(totalsavings) }}</b>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Withdraws</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Charges</th>
                          <th>Payment Mode</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in withdraws" :key="item.id">
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ commas(item.charges) }}</td>
                          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
                          <td>{{ item.withdraw_date }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col">
                        <b>Total Withdraws : {{ commas(totalwithdraws) }}</b>
                      </div>
                      <div class="col text-center">
                        <b>Total Charges : {{ commas(totalcharges) }}</b>
                      </div>
                      <div class="col"></div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Shares</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Shares</th>
                          <th>Payment Mode</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in shares" :key="item.id">
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ commas(item.share) }}</td>
                          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
                          <td>{{ item.date_of_payment }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <b>Total Shares : {{ commas(totalshares) }}</b>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Loans</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Loan</th>
                          <th>Amount</th>
                          <th>Interest</th>
                          <th>Payback</th>
                          <th>Paid</th>
                          <th>Disbursement Date</th>
                          <th>Full Payment</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in loans" :key="item.id">
                          <td>{{ item.loan_type.name }} <br><small class="text-info"> {{ item.loan_type.rate }}% {{
                            item.loan_type.period }} days</small></td>
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ commas(item.interest) }}</td>
                          <td>{{ commas(item.payback) }}</td>
                          <td>{{ commas(item.paid) }}</td>
                          <td>{{ item.disbursement_date }}</td>
                          <td>{{ item.expirydate }}</td>
                          <td>
                            <b class="text-warning" v-if="item.status == '1'">Applied</b>
                            <b class="text-success" v-else-if="item.status == '2'">Approved</b>
                            <b class="text-info" v-else-if="item.status == '3'">Running</b>
                            <b class="text-primary" v-else-if="item.status == '4'">Closed</b>
                            <b class="text-danger" v-else-if="item.status == '5'">Written Off</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col">
                        <b>Total Loans : {{ commas(totalloan) }}</b>
                      </div>
                      <div class="col text-center">
                        <b>Total Paid : {{ commas(totalpaid) }}</b>
                      </div>
                      <div class="col"></div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Subscription Fees</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Payment Mode</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in membershipfees" :key="item.id">
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
                          <td>{{ item.date_of_payment }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <b>Total Subscriptions : {{ commas(totalsubscription) }}</b>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Registration Fees</template>
                <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Payment Mode</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in registrationfees" :key="item.id">
                          <td>{{ commas(item.amount) }}</td>
                          <td>{{ item.mode_of_payment.name }} - {{ item.reference }}</td>
                          <td>{{ item.date_of_payment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="resetPasswordModal" centered title="Reset Password" hide-footer>

      <div class="form-group mb-2">
        <label>Are you sure you want to reset password for this member?</label><br>
        <small class="text-danger">Password resets to '123456'</small>
      </div>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary"
          @click="$bvModal.hide('resetPasswordModal')">Cancel</b-button>
        <b-button @click.prevent="resetPassword" class="btn ms-1 w-30" variant="danger">
          <b-spinner small v-if="loader1"></b-spinner>
          <span v-else><i class="fas fa-check-circle"></i> Reset!</span>
        </b-button>
      </div>

    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Member Profile",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Member Profile",
      items: [{ text: "Dashboard", to: "/", }, { text: "Members", active: true, },],
      userData: JSON.parse(localStorage.getItem("user")),
      members: [],
      savings: [], savingbalance: '',
      withdraws: [],
      shares: [],
      loans: [],
      transfers: [],
      membershipfees: [],
      registrationfees: [],
      reset_member_id: '',
      loader: false,  //Loader for bringing Password Reset Modal
      loader1: false,  //Loader for submitting Password Reset
    };
  },
  created() {
    this.showmember();
    this.showsavings();
  },
  computed: {
    totalsubscription() { var total = 0; this.membershipfees.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalsavings() { var total = 0; this.savings.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalwithdraws() { var total = 0; this.withdraws.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalcharges() { var total = 0; this.withdraws.forEach((item) => { var item_total = item.charges; total = Number(total) + Number(item_total); }); return total },
    totalshares() { var total = 0; this.shares.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalloan() { var total = 0; this.loans.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    totalpaid() { var total = 0; this.loans.forEach((item) => { var item_total = item.paid; total = Number(total) + Number(item_total); }); return total },
  },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getAge(dateString) {
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => { birth.setDate(now.getDate()); birth.setMonth(now.getMonth()); return birth.getTime() })() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth + 1;
    },
    async showmember() {
      this.member_id = this.$route.query.id;
      let url = `/memberprofile/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.members = response.data.members;
      });
    },
    async showsavings() {
      this.member_id = this.$route.query.id;
      let url = `/profilesavings/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.savings = response.data.savings;
        this.showwithdraw();
        this.showshares();
        this.showloans();
        this.showmembership();
        this.showregistration();
        this.FindBalance();
      });
    },
    async FindBalance() {
      this.member_id = this.$route.query.id;
      let url = `/savingsbalance/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.savingbalance = response.data.balance;
      });
    },
    async showwithdraw() {
      this.member_id = this.$route.query.id;
      let url = `/profilewithdraws/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.withdraws = response.data.withdraws;
      });
    },
    async showshares() {
      this.member_id = this.$route.query.id;
      let url = `/profileshares/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.shares = response.data.shares;
      });
    },
    async showregistration() {
      this.member_id = this.$route.query.id;
      let url = `/profileregistrationfees/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.registrationfees = response.data.registrationfees;
      });
    },
    async showmembership() {
      this.member_id = this.$route.query.id;
      let url = `/profilemembershipfees/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.membershipfees = response.data.membershipfees;
      });
    },
    async showloans() {
      this.member_id = this.$route.query.id;
      let url = `/profileloans/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.loans = response.data.loans;
      });
    },
    async showtransfers() {
      this.member_id = this.$route.query.id;
      let url = `/profiletransfers/${this.member_id}`;
      await axios.get(url).then((response) => {
        this.transfers = response.data.transfers;
      });
    },

    showResetPasswordModal(id) {
      this.loader = true;
      this.reset_member_id = id;
      this.$bvModal.show('resetPasswordModal')
      this.loader = false;
    },

    async resetPassword() {
      this.loader1 = true;
      const url = 'reset-password';
      let obj = {
        member_id: this.reset_member_id
      }
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.$toast.success("Password Reset Successfully to '123456'");
          this.reset_member_id = '';
          this.$bvModal.hide('resetPasswordModal');
          this.loader1 = false;
        } else {
          this.$toast.error("Password Reset Failed");
          this.loader1 = false;
        }
      });
    },
  },
};
</script>